export default "__VITE_ASSET__DGXsp0jQ__"